import React from 'react';
import { Switch } from 'react-router-dom';
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import VirtualFenceList from './virtual-fence-list';
import VirtualFenceCircleDetail from './virtual-fence-circle-detail';
import VirtualFenceCircleDeleteDialog from './virtual-fence-circle-delete-dialog';
import VirtualFencePolygonDeleteDialog from 'app/entities/virtual-fence-polygon/virtual-fence-polygon-delete-dialog';

import { VirtualFence as CircularEditor } from 'app/modules/virtual-fence-map/index';
import { VirtualFencePolygon as PolygonEditor } from 'app/modules/virtual-fence-polygon-map/index';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/polygon/new`} component={PolygonEditor} />
      <ErrorBoundaryRoute exact path={`${match.url}/polygon/:id/edit`} component={PolygonEditor} />
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={CircularEditor} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={CircularEditor} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={VirtualFenceCircleDetail} />
      <ErrorBoundaryRoute path={match.url} component={VirtualFenceList} />
    </Switch>

    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={VirtualFenceCircleDeleteDialog} />
    <ErrorBoundaryRoute exact path={`${match.url}/polygon/:id/delete`} component={VirtualFencePolygonDeleteDialog} />
  </>
);

export default Routes;
